<template>
  <div class="face-conent">
    <p class="mb-24"
      >为了不影响您的孩子{{ name }}正常进出校，请尽快为孩子录入人脸。</p
    >
    <div>
      <p class="m-0-auto mb-16 text-center h-90 w-90 bd-p-50 bg-F5F5F5 lh-90">
        <i class="iconfont font-100 c-C0C0C0">&#xe651;</i>
      </p>
      <p class="mb-24 font-34 text-center text-bold-600">{{ name }}</p>
    </div>
    <div>
      <p
        class="bd-radio-8 lh-46 font-36 text-center c-FFFFFF bg-4250C3"
        @click="handlerFaceClick"
        >拍照录脸</p
      >
    </div>
  </div>
</template>

<script>
import { mcOpenLink } from '@/utils/mcSdkUtils'
import { enterFace } from '@/utils/comUtils'
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      faceSourceType: 0 // 1:ding人脸库，2：魔方人脸库 3: 拱墅人脸库
    }
  },
  created() {
    this.methodsGetFaceSource()
  },
  activated() {
    this.methodsGetFaceSource()
  },
  methods: {
    methodsGetFaceSource() {
      this.getApi('getFaceSource', {}).then(res => {
        this.faceSourceType = +res
      })
    },
    handlerFaceClick() {
      mcOpenLink({
        url: enterFace(this.faceSourceType, this.corpId, 1)
      })
    }
  }
}
</script>

<style></style>
